/**
 * Token storage interface
 * Platform-agnostic storage contract
 */

import type { AuthTokens } from "../types";

export interface TokenStorage {
  /** Store tokens */
  setTokens(tokens: AuthTokens): Promise<void>;
  /** Retrieve tokens */
  getTokens(): Promise<AuthTokens | null>;
  /** Clear tokens */
  clearTokens(): Promise<void>;
  /** Check if tokens exist */
  hasTokens(): Promise<boolean>;
}

export const STORAGE_KEYS = {
  ACCESS_TOKEN: "fmc_access_token",
  ID_TOKEN: "fmc_id_token",
  REFRESH_TOKEN: "fmc_refresh_token",
  EXPIRES_AT: "fmc_expires_at",
  TOKEN_TYPE: "fmc_token_type",
} as const;
